import { render } from "./TaskForm.vue?vue&type=template&id=2d1ba5d0&scoped=true"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"

import "./TaskForm.vue?vue&type=style&index=0&id=2d1ba5d0&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1ba5d0"]])

export default __exports__